const localization = {
    cannot_delete_default_language: '{{languageTag}} está establecido como tu idioma predeterminado y no se puede eliminar.',
    invalid_translation_structure: 'Estructuras de datos no válidas. Por favor, verifica tu entrada e intenta de nuevo.',
};
export default localization;
